import { render, staticRenderFns } from "./reviewers.vue?vue&type=template&id=781b9352"
import script from "./reviewers.vue?vue&type=script&lang=js"
export * from "./reviewers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports